(() => {
  function setup(root) {
    if(root.dataset.ready)return;root.dataset.ready='true';
    const labels=JSON.parse(root.querySelector('[data-camp-labels]').textContent);
    const form=root.querySelector('[data-application-form]');
    const steps=[...form.querySelectorAll('[data-step]')];
    const next=form.querySelector('[data-next]'),back=form.querySelector('[data-back]'),send=form.querySelector('[data-submit]');
    const error=form.querySelector('[data-form-error]');
    let step=0,started=false,busy=false,session=null,requestId=crypto.randomUUID();
    const analyticsAllowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
    const source=()=>{
      if(!analyticsAllowed())return {};
      const params=new URLSearchParams(location.search),s={};
      ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(k=>{const v=params.get(k);if(v&&/^[a-zA-Z0-9_. /-]{1,80}$/.test(v))s[k]=v;});
      try{if(document.referrer)s.referrer=new URL(document.referrer).hostname;}catch{}
      return s;
    };
    async function api(data) {
      const response=await fetch(root.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json',apikey:root.dataset.apiKey},body:JSON.stringify(data),signal:AbortSignal.timeout(25000)});
      const result=await response.json();
      if(!response.ok)throw Object.assign(new Error(result.error||labels.error),{fields:result.fields});
      return result;
    }
    function event(name) {
      if(!analyticsAllowed()||window.Shopify?.designMode)return;
      if(!session){try{session=sessionStorage.getItem('fm-camp-analytics-session')||crypto.randomUUID();sessionStorage.setItem('fm-camp-analytics-session',session);}catch{session=crypto.randomUUID();}}
      const payload={action:'event',name,session_id:session,analytics_consent:true,source:source()};
      api(payload).catch(()=>{});
      window.Shopify?.analytics?.publish?.(`fivemore_camp:${name}`,{season:'001'});
    }
    function start(){if(!started){started=true;event('application_start');}}
    form.addEventListener('focusin',start,{once:true});
    root.querySelectorAll('[data-apply-link]').forEach(a=>a.addEventListener('click',start));
    document.addEventListener('visitorConsentCollected',()=>event('page_view'));
    if(window.Shopify?.loadFeatures&&!window.Shopify.customerPrivacy)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>event('page_view'));else event('page_view');
    root.querySelectorAll('video').forEach(v=>v.addEventListener('play',()=>event('film_play'),{once:true}));
    const tabs=[...root.querySelectorAll('[data-day]')],panels=[...root.querySelectorAll('[role=tabpanel]')];
    function day(index,focus=false){if(!tabs[index])return;tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(index===i));t.tabIndex=index===i?0:-1;});panels.forEach((p,i)=>p.hidden=i!==index);if(focus)tabs[index].focus();event('day_select');}
    tabs.forEach((t,i)=>{t.addEventListener('click',()=>day(i));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();day(n,true);});});
    root.querySelectorAll('[data-day-link]').forEach(a=>a.addEventListener('click',()=>day(Number(a.dataset.dayLink))));
    const getData=()=>{
      const f=new FormData(form),d=Object.fromEntries(f.entries());
      ['age_confirmed','charlotte_confirmed','filming_confirmed','contact_consent','marketing_consent'].forEach(k=>d[k]=f.get(k)==='on');
      d.links=[d.link1,d.link2,d.link3].map(v=>String(v||'').trim()).filter(Boolean);
      delete d.link1;delete d.link2;delete d.link3;
      return {...d,action:'apply',request_id:requestId,analytics_consent:analyticsAllowed(),source:source()};
    };
    function review(){
      const d=getData(),container=form.querySelector('[data-review]');container.replaceChildren();
      const fields=['name','artist_name','email','role','links','sound','why','contribution','availability'];
      const names=labels.review_labels.split('|');
      fields.forEach((key,i)=>{
        if(!d[key]||!d[key].length)return;
        const item=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=names[i];
        if(key==='links')d.links.forEach(url=>{const a=document.createElement('a');a.href=url;a.textContent=url;a.target='_blank';a.rel='noopener noreferrer';dd.append(a);});else dd.textContent=d[key];
        item.append(dt,dd);container.append(item);
      });
    }
    function show(index,focus=true){
      step=index;steps.forEach((s,i)=>s.hidden=i!==index);
      form.querySelectorAll('.camp-progress li').forEach((li,i)=>{if(i===index)li.setAttribute('aria-current','step');else li.removeAttribute('aria-current');li.toggleAttribute('data-done',i<index);});
      back.hidden=index===0;next.hidden=index===3;send.hidden=index!==3;
      form.querySelector('[data-step-count]').textContent=labels.step.replace('{step}',index+1);
      error.hidden=true;
      if(index===3)review();
      if(focus){const legend=steps[index].querySelector('legend');legend.tabIndex=-1;legend.focus();if(index)event(`application_step_${index+1}`);}
    }
    function valid(index){
      let first=null;
      steps[index].querySelectorAll('input,select,textarea').forEach(input=>{
        input.setCustomValidity('');
        if(input.value&&input.type==='url'){try{const u=new URL(input.value);if(u.protocol!=='https:'||u.username||u.password||!u.hostname.includes('.'))input.setCustomValidity(labels.https);}catch{input.setCustomValidity(labels.https);}}
        if(input.type!=='checkbox'&&input.required&&!input.value.trim())input.setCustomValidity(labels.required);
        if(input.minLength>0&&input.value.trim().length<input.minLength)input.setCustomValidity(labels.required);
        const ok=input.checkValidity();input.setAttribute('aria-invalid',String(!ok));if(!ok&&!first)first=input;
      });
      if(first){error.textContent=labels.required;error.hidden=false;first.focus();first.reportValidity();return false;}return true;
    }
    next.addEventListener('click',()=>{if(!busy&&valid(step))show(Math.min(step+1,3));});
    back.addEventListener('click',()=>{if(!busy)show(Math.max(step-1,0));});
    form.addEventListener('input',e=>{if(e.target.setCustomValidity){e.target.setCustomValidity('');e.target.removeAttribute('aria-invalid');}});
    form.addEventListener('submit',async e=>{
      e.preventDefault();if(busy)return;
      if(step<3){if(valid(step))show(step+1);return;}
      for(let i=0;i<4;i++){if(!valid(i)){show(i,false);valid(i);return;}}
      busy=true;send.disabled=true;back.disabled=true;send.textContent=labels.sending;error.hidden=true;
      try{
        const result=await api(getData());
        if(!result.ok||!result.receipt)throw new Error(labels.error);
        form.hidden=true;const success=root.querySelector('[data-success]');success.hidden=false;success.querySelector('[data-receipt]').textContent=labels.reference+result.receipt;success.focus();event('application_submit');
      }catch(e){
        if(e.fields){const key=Object.keys(e.fields)[0];const field=form.elements.namedItem(key==='links'?'link1':key);if(field){show(Number(field.closest('[data-step]').dataset.step),false);field.setAttribute('aria-invalid','true');field.focus();}}
        error.textContent=e.name==='TimeoutError'?labels.error:e.message||labels.error;error.hidden=false;
      }finally{busy=false;send.disabled=false;back.disabled=false;send.textContent=labels.submit;}
    });
    const follow=root.querySelector('[data-follow-form]');
    follow.addEventListener('submit',async e=>{
      e.preventDefault();if(!follow.reportValidity())return;
      const button=follow.querySelector('button'),status=follow.querySelector('[data-follow-status]');button.disabled=true;status.textContent='';
      try{await api({action:'follow',email:follow.elements.email.value,marketing_consent:follow.elements.marketing_consent.checked,analytics_consent:analyticsAllowed(),source:source()});status.textContent=labels.follow_success;follow.reset();event('follow_submit');}
      catch(e){status.textContent=e.message||labels.error;}finally{button.disabled=false;}
    });
    show(0,false);
  }
  const boot=()=>document.querySelectorAll('[data-camp]').forEach(setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
